import { Box, Typography, Paper } from '@mui/material';
import { ElementType } from 'react';

interface DocumentTextChunksProps {
    textChunks: {
        [key: number]: { content: string, score: number }
    };
}

export const TextChunks: ElementType<DocumentTextChunksProps> = ({ textChunks }) => {
    return (
        <Box
            sx={{
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                backgroundColor: 'background.paper',
                paddingTop: 0,
                paddingX: 2,
                paddingBottom: 2
            }}
        >
            <Typography variant="h6" my={1} sx={{ color: '#1f2937', flexShrink: 0 }}>
                Text Chunks
            </Typography>
            <Box
                sx={{
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 0,
                    backgroundColor: 'background.paper',
                }}
            >
                {
                    Object.keys(textChunks).map((key, index) => (
                        <Paper
                            key={index}
                            elevation={0}
                            sx={{
                                padding: 2,
                                margin: 0,
                                borderRadius: 0,
                                backgroundColor: 'white',
                                borderBottom: '1px solid',
                                borderColor: 'divider'
                            }}
                        >
                            <Typography variant="body1" sx={{ fontFamily: 'monospace', fontSize: '0.75rem' }} >
                                {textChunks[Number(key)].content}
                            </Typography>
                        </Paper>
                    ))
                }
            </Box>
        </Box>
    );
};
